define.alias("shared/components/shared/post/secondary/hashtag-suggestions/auto", "calendar/components/shared/post/secondary/hashtag-suggestions/auto");